import type { IconProps } from '@magicschool/spellbook/components/Icon';
import { Icon } from '@magicschool/spellbook/components/Icon';
import { Slot } from '@magicschool/spellbook/components/Slot';

export const BadgeLeadingIconSlot = Slot<IconProps>({
  displayName: 'Badge.LeadingIcon',
  preventOverride: true,
  renderDefault: ({ name = 'square-dashed', className, color = 'default', size: _, ...props }) => {
    return <Icon data-spellbook-name="badge-leading-icon" name={name} color={color} size="sm" className={className} {...props} />;
  },
});

export const BadgeTrailingIconSlot = Slot<IconProps>({
  displayName: 'Badge.TrailingIcon',
  preventOverride: true,
  renderDefault: ({ name = 'square-dashed', className, color = 'default', size: _, ...props }) => (
    <Icon data-spellbook-name="badge-trailing-icon" name={name} color={color} size="sm" className={className} {...props} />
  ),
});
